import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { PROMO_CODE, REPs } from "../../config";
import { PlanProps } from "../../types";
import { getBestRate, getBestValue, getPlanName } from "../data";
import { Button } from "./../styles/Button.styled";
import { PlanSummaryPromote, PlanSummaryRow } from "./../styles/Enrollment.styled";
import { StyledPlanList, StyledPlanRow, StyledPlanTitle } from "./../styles/Plan.styled";
import { openPdfInNewTab } from "../consteNew/utils";



export const PlanModal = ({ show, handleClose, data, selectProduct, hideCloseButton, promoCode, avgMonthlyUse }: {
    show: boolean;
    handleClose: Function;
    data: PlanProps[];
    selectProduct: Function;
    hideCloseButton?: boolean;
    promoCode?: string,
    avgMonthlyUse?: string
}) => {
    const priceType = `price${avgMonthlyUse}`
    let showTitle = false;
    const hostRep = REPs.filter(val => val.host === true);
    const flex = data.length === 1 ? 92 : 46;
    if (hostRep[0] && data && data[0] && String(hostRep[0].providerId) === String(data[0].provider_id)) {
        showTitle = true;
    }

    let bestRatePlan: any = [], bestValuePlan: any = [];

    if (data) {
        data.map((item) => {
            item.show_plan_name = getPlanName(item, promoCode);
        })
        const BestValue = getBestValue(promoCode);
        const BestRate = getBestRate(promoCode);

        // bestRatePlan = data.filter((item) => item.show_plan_name?.indexOf('Credit') && item.show_plan_name?.indexOf('Credit') > -1)
        bestValuePlan = data.filter((item) => BestValue.indexOf(Number(item.plan_id)) > -1)
        bestRatePlan = data.filter((item) => BestRate.indexOf(Number(item.plan_id)) > -1).sort((a, b) => Number(a.contract_term) < Number(b.contract_term) ? -1 : 1)

    }

    return (
        <Modal size={data.length === 1 ? undefined : 'lg'} show={show} onHide={() => { handleClose() }}>
            <Modal.Header style={{ /*display: 'unset'*/ }} closeButton={!hideCloseButton}>
                <Modal.Title style={{ color: '#2372B9', maxWidth: '70%', textAlign: 'left', lineHeight: 1 }}>{showTitle ? 'Best plans for you' : 'Plans'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <StyledPlanList>
                    {
                        !showTitle && data && data.map((item: PlanProps, idx: number) => <PlanRow data={item} handleSelectProduct={selectProduct} key={idx} flex={flex} priceType={priceType || "price1000"} avgMonthlyUse={avgMonthlyUse} />)
                    }
                    {
                        data && bestRatePlan.length !== 0 && <StyledPlanTitle >{promoCode === PROMO_CODE ? "Best Rate" : "A/C Protect Plan"}</StyledPlanTitle>
                    }
                    {
                        data && bestRatePlan.length !== 0 && bestRatePlan.map((item: PlanProps, idx: number) => <PlanRow data={item} handleSelectProduct={selectProduct} key={idx} flex={flex} priceType={priceType || "price1000"} avgMonthlyUse={avgMonthlyUse} />)
                    }
                    {
                        data && bestValuePlan.length !== 0 && <StyledPlanTitle>{promoCode === PROMO_CODE ? "Best Value" : "Standard Electricity"}</StyledPlanTitle>
                    }
                    {
                        data && bestValuePlan.length !== 0 && bestValuePlan.map((item: PlanProps, idx: number) => <PlanRow data={item} handleSelectProduct={selectProduct} key={idx} flex={flex} priceType={priceType || "price1000"} avgMonthlyUse={avgMonthlyUse} />)
                    }
                    {
                        data.length === 0 && <h5>No data found</h5>
                    }
                </StyledPlanList>
            </Modal.Body>
        </Modal >
    )
}

const PlanRow = ({ data, handleSelectProduct, flex, priceType, avgMonthlyUse }: {
    data: any;
    handleSelectProduct: Function;
    flex: Number
    priceType: string
    avgMonthlyUse?: string
}) => {
    const navigate = useNavigate();
    const {
        isEbillRequired,
        provider_id,
        plan_name,
        price1000,
        contract_term,
        cancel_fee,
        cancel_fee_type,
        rate,
        total_rate,
        show_plan_name,
        month,
        plan_incentive_list
    } = data;
    const location = useLocation();
    const hostRep = REPs.filter(val => val.host === true);
    let showBtn = false;
    if (hostRep[0] && hostRep[0].providerId.toString() === provider_id.toString()) {
        showBtn = true;
    }

    return <StyledPlanRow style={{ flex: `0 0 ${flex}%` }}>
        <div>
            <div className="d-flex align-items-center mb-3">
                <div className="rep-logo me-3" style={{ flexShrink: 0 }}>
                    <img src={provider_id === "196" ? "/images/logo.png" : `https://www.powerlego.com/ApiGateway/v2/logo/provider/${provider_id}`} width="100%" style={{ maxWidth: 125 }} alt="" />
                </div>
                <div className="plan-name">{show_plan_name}</div>
            </div>
            <div>
                <PlanSummaryRow>
                    <label>Rate{/* (Based on 1,000 kWh) */}:</label>
                    {
                        priceType && data[priceType] ? <span>
                            <b>{`${priceType ? Number(data[priceType]).toFixed(1) : rate}¢`}</b>
                        </span> : avgMonthlyUse ?
                            <span>
                                <b>{`${(month[1] / Number(avgMonthlyUse) * 100).toFixed(1)}¢`}</b>
                            </span> :
                            <span>
                                <b>{`${rate}¢`}</b>
                            </span>
                    }

                </PlanSummaryRow>
                <PlanSummaryRow>
                    <label>{('Plan Length')}:</label>
                    <span>{contract_term} Months</span>
                </PlanSummaryRow>
                {
                    plan_incentive_list?.find((incentive: any) => incentive.Description === 'Gift Card') &&
                    <div>
                        <PlanSummaryRow>
                            <label>Gift Card{/* (Based on 1,000 kWh) */}:</label>
                            <span>
                                <b>${plan_incentive_list?.find((incentive: any) => incentive.Description === 'Gift Card')?.Value}</b>
                            </span>
                        </PlanSummaryRow>
                    </div>
                }
                {
                    cancel_fee && cancel_fee_type &&
                    <PlanSummaryRow>
                        <label>{('Cancellation Fee')}:</label>
                        <span style={{ textAlign: 'right' }}>
                            {`${cancel_fee} (${cancel_fee_type})`}
                        </span>
                    </PlanSummaryRow>
                }
            </div>
            <div className="plan-links mt-3">
                {
                    data.yrac &&
                    <PlanSummaryRow key={1} narrow>
                        <span onClick={(e) => { e.preventDefault(); openPdfInNewTab(data.yrac); }}>
                            <FontAwesomeIcon icon="file-pdf" />
                            <span className="ms-2">YRAC</span>
                        </span>
                    </PlanSummaryRow>
                }

                {
                    data.terms_url &&
                    <PlanSummaryRow key={2} narrow>
                        <span onClick={(e) => { e.preventDefault(); openPdfInNewTab(data.terms_url); }}>
                            <FontAwesomeIcon icon="file-pdf" />
                            <span className="ms-2">TOS</span>
                        </span>
                    </PlanSummaryRow>
                }

                {
                    data.efl_url &&
                    <PlanSummaryRow key={3} narrow>
                        <span onClick={(e) => { e.preventDefault(); openPdfInNewTab(data.efl_url); }}>
                            <FontAwesomeIcon icon="file-pdf" />
                            <span className="ms-2">EFL</span>
                        </span>
                    </PlanSummaryRow>
                }
            </div>
            <PlanSummaryPromote>{isEbillRequired && <span>Plan requires electronic billing. </span>}Please print or save these documents for your reference.</PlanSummaryPromote>
        </div>
        {
            showBtn &&
            <Button className="mt-3" onClick={() => {
                handleSelectProduct(data);
                localStorage.setItem('selectProduct', JSON.stringify(data))
                navigate(`/enrollment/step1${location.search}`);
            }}>Select Plan</Button>
        }
    </StyledPlanRow>
}